<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import Datatable from "@/router/layouts/table-datatable-nohover.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";

// import $ from "jquery";

export default {
  page: {
    title: "Kalender Akademik Tahunan",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    FullCalendar,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "150px", label: "Kode Pembelajaran", name: "-" },
      { width: "100px", label: "Tgl Mulai", name: "-" },
      { width: "100px", label: "Tgl Selesai", name: "-" },
      { width: "auto", label: "Jenis Pembelajaran", name: "-" },
      { width: "auto", label: "Angkatan", name: "-" },
      { width: "auto", label: "Judul Pembelajaran", name: "-" },
      { width: "100px", label: "Total Peserta", name: "-" },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    // definisi kolom yang dipakai
    let wcolumns = [
      { width: "50px", label: "No", name: "-" },
      { width: "150px", label: "Kode Pembelajaran", name: "-" },
      { width: "100px", label: "Tgl Mulai", name: "-" },
      { width: "100px", label: "Tgl Selesai", name: "-" },
      { width: "auto", label: "Jenis Pembelajaran", name: "-" },
      { width: "auto", label: "Angkatan", name: "-" },
      { width: "auto", label: "Judul Pembelajaran", name: "-" },
      { width: "100px", label: "Total Peserta", name: "-" },
    ];

    // cek sorting
    wcolumns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Kalender Akademik Tahunan",
      items: [
        {
          text: "Data Pembelajaran",
          href: "/",
        },
        {
          text: "Kalender Akademik",
          href: "/",
        },
        {
          text: "Tahunan",
          active: true,
        },
      ],
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      loadingDetail: false,

      calendarOptions: {
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        editable: false,
        droppable: false,
        eventResizableFromStart: true,
        eventClick: this.eventClick,
        weekends: true,
        selectable: false,
        selectMirror: true,
        dayMaxEvents: true,
        events: function (info, successCallback) {
          Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          let resMonth = info.start;
          let currMonth = new Date(resMonth.setDate(info.start.getDate() + 15));
          let yearMonth = `${currMonth.getFullYear()}-${
            currMonth.getMonth() + 1
          }`;

          let conf = {
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "transactions/kalender-tahunan",
            method: "get",
            params: { yearMonth },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          };

          axios(conf)
            .then((res) => {
              let resFix = res.data.data[0][0];
              resFix = JSON.parse(resFix);
              resFix = JSON.parse(resFix[0].get_kalender_akademik);
              let events = [];
              if (resFix) {
                let currDate = moment();
                resFix.forEach((elm) => {
                  if (elm.totalClass > 0) {
                    let className = "bggray mdi mdi-bell-off text-dark";
                    let date = moment(elm.date);
                    if (date > currDate) {
                      className = "bg-primary mdi mdi-bell text-white";
                    } else if (
                      date.format("YYYY-MM-DD") == currDate.format("YYYY-MM-DD")
                    ) {
                      className = "bg-success mdi mdi-bell text-white";
                    }

                    let temp = {
                      id: elm.date,
                      title: `${elm.totalClass} Kelas`,
                      start: Date.parse(elm.date),
                      allDay: true,
                      className: className,
                    };
                    events.push(temp);
                  }
                });
              }
              successCallback(events);
              Swal.close();
            })
            .catch((err) => {
              console.log(err);
              Swal.close();
            });
        },
      },
      eventModal: false,
      event: {
        title: "",
        date: "",
        totalPeserta: "",
        totalKelas: "",
      },
      wevent: {
        title: "",
        totalPeserta: "",
        totalKelas: "",
      },

      // variable Page Table
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "le_id", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",

      // parsing data ke table data
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "asc",
        filter_status: "ENABLE",
        date: null,
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },

      // variable Page Table
      wloadingTable: true,
      wtable_data: [],
      wcolumns: columns,
      wsortKey: "le_id", // sort key awal
      wsortOrders: sortOrders,
      wcurrentTablePage: "",

      // parsing data ke table data
      wtableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "asc",
        filter_status: "ENABLE",
        date: null,
      },

      // config untuk paginasi
      wpagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  mounted() {},
  methods: {
    eventClick(info) {
      this.getDate(info);
      this.getWeek(info);
    },
    getDate(info) {
      let self = this;
      let date = moment(info.event.id).format("D MMMM YYYY");
      let totPeserta = 0;
      let totKelas = 0;
      self.loadingDetail = true;
      self.loadingTable = true;
      self.eventModal = true;
      self.tableData.date = info.event.id;

      let conf = {
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/kalender-tahunan/get-date",
        method: "get",
        params: self.tableData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(conf)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            if (self.tableData.draw == response_data_fix.draw) {
              self.table_data = response_data_fix.list_data.data;
              self.configPagination(response_data_fix.list_data);
              self.currentTablePage = response_data_fix.list_data.current_page;
              totKelas = response_data_fix.total_kelas;
              totPeserta = response_data_fix.total_peserta_kelas;
            }
            self.event = {
              title: date,
              date: moment(date).format("YYYY-MM-DD"),
              totalKelas: totKelas,
              totalPeserta: totPeserta,
            };
            self.loadingDetail = false;
            self.loadingTable = false;
            self.wloadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWeek(info) {
      let self = this;
      let date = moment(info.event.id).format("D MMMM YYYY");
      let wtotPeserta = 0;
      let wtotKelas = 0;
      let wweek = "Minggu ke-";
      self.wtableData.date = info.event.id;
      self.wloadingTable = true;

      let conf = {
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/kalender-tahunan/get-week",
        method: "get",
        params: self.wtableData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(conf)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            if (self.wtableData.draw == response_data_fix.draw) {
              self.wtable_data = response_data_fix.list_data.data;
              self.wconfigPagination(response_data_fix.list_data);
              self.wcurrentTablePage = response_data_fix.list_data.current_page;
              wtotKelas = response_data_fix.total_kelas;
              wtotPeserta = response_data_fix.total_peserta_kelas;
              wweek = `${moment(date).format("MMMM")} Minggu ke- ${
                response_data_fix.week[0].week
              }`;
            }
            self.wevent = {
              title: wweek,
              date: moment(date).format("YYYY-MM-DD"),
              totalKelas: wtotKelas,
              totalPeserta: wtotPeserta,
            };
            self.loadingDetail = false;
            self.wloadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    configPagination(data) {
      let self = this;
      self.pagination.lastPage = data.last_page;
      self.pagination.currentPage = data.current_page;
      self.pagination.total = data.total;
      self.pagination.lastPageUrl = data.last_page_url;
      self.pagination.nextPageUrl = data.next_page_url;
      self.pagination.prevPageUrl = data.prev_page_url;
      self.pagination.from = data.from;
      self.pagination.to = data.to;
      self.pagination.links = data.links;
    },
    wconfigPagination(data) {
      let self = this;
      self.wpagination.lastPage = data.last_page;
      self.wpagination.currentPage = data.current_page;
      self.wpagination.total = data.total;
      self.wpagination.lastPageUrl = data.last_page_url;
      self.wpagination.nextPageUrl = data.next_page_url;
      self.wpagination.prevPageUrl = data.prev_page_url;
      self.wpagination.from = data.from;
      self.wpagination.to = data.to;
      self.wpagination.links = data.links;
    },

    closeModal() {
      this.eventModal = false;
    },
  },
};
</script>
<style>
.bggray {
  background-color: #dcdfe5;
}

th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar
                ref="fullCalendar"
                :options="calendarOptions"
                @datesRender="handleMonthChange"
              ></FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal
      size="lg"
      v-model="eventModal"
      title="Detail Kelas"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
    >
      <div v-if="loadingDetail" class="row">
        <div class="col-12 text-center">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>
      </div>
      <div v-else class="mb-3">
        <h4 class="text-center mb-4">{{ event.title }}</h4>
        <div class="row">
          <div class="col col-md-6 col-sm-12 text-center">
            <div class="avatar-md mx-auto mb-3">
              <div class="avatar-title bg-light rounded-circle text-primary h1">
                <i class="bx bx-chalkboard"></i>
              </div>
            </div>
            <h5 class="text-primary">{{ event.totalKelas }} Kelas</h5>
          </div>
          <div class="col col-md-6 col-sm-12 text-center">
            <div class="avatar-md mx-auto mb-3">
              <div class="avatar-title bg-light rounded-circle text-primary h1">
                <i class="bx bx-group"></i>
              </div>
            </div>
            <h5 class="text-primary">{{ event.totalPeserta }} Peserta</h5>
          </div>
        </div>
        <div class="row">
          <div class="col mt-2">
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td colspan="16" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data == ''">
                  <td class="text-center" colspan="16">Data Tidak Tersedia</td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="key_data"
                >
                  <template v-if="event.date == row_data.pbl_tgl_selesai">
                    <td
                      class="text-center"
                      style="background-color: #2980b9; color: #fff"
                    >
                      <div v-if="key_data + 1 == 10">
                        {{ currentTablePage }}0.
                      </div>
                      <div v-else>
                        {{
                          currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
                        }}{{ key_data + 1 }}.
                      </div>
                    </td>
                    <td style="background-color: #2980b9; color: #fff">
                      {{ row_data.pbl_kode }}
                    </td>
                    <td
                      class="text-center"
                      style="background-color: #2980b9; color: #fff"
                    >
                      {{ row_data.pbl_tgl_mulai }}
                    </td>
                    <td
                      class="text-center"
                      style="background-color: #2980b9; color: #fff"
                    >
                      {{ row_data.pbl_tgl_selesai }}
                    </td>
                    <td
                      class="text-center"
                      style="background-color: #2980b9; color: #fff"
                    >
                      {{ row_data.pbl_lt_name }}
                    </td>
                    <td
                      class="text-center"
                      style="background-color: #2980b9; color: #fff"
                    >
                      {{ row_data.pbl_angkatan }}
                    </td>
                    <td style="background-color: #2980b9; color: #fff">
                      {{ row_data.pbl_judul }}
                    </td>
                    <td
                      class="text-center"
                      style="background-color: #2980b9; color: #fff"
                    >
                      {{ row_data.total_peserta }} Org
                    </td>
                  </template>
                  <template v-else>
                    <td class="text-center">
                      <div v-if="key_data + 1 == 10">
                        {{ currentTablePage }}0.
                      </div>
                      <div v-else>
                        {{
                          currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
                        }}{{ key_data + 1 }}.
                      </div>
                    </td>
                    <td>{{ row_data.pbl_kode }}</td>
                    <td class="text-center">{{ row_data.pbl_tgl_mulai }}</td>
                    <td class="text-center">{{ row_data.pbl_tgl_selesai }}</td>
                    <td class="text-center">{{ row_data.pbl_lt_name }}</td>
                    <td class="text-center">{{ row_data.pbl_angkatan }}</td>
                    <td>{{ row_data.pbl_judul }}</td>
                    <td class="text-center">
                      {{ row_data.total_peserta }} Org
                    </td>
                  </template>
                </tr>
              </tbody>
            </datatable>
          </div>
          <pagination :pagination="pagination" @to-page="toPage"></pagination>
        </div>
        <hr />
        <div>
          <h4 class="text-center mb-4">{{ wevent.title }}</h4>
          <div class="row">
            <div class="col col-md-6 col-sm-12 text-center">
              <div class="avatar-md mx-auto mb-3">
                <div
                  class="avatar-title bg-light rounded-circle text-primary h1"
                >
                  <i class="bx bx-chalkboard"></i>
                </div>
              </div>
              <h5 class="text-primary">{{ wevent.totalKelas }} Kelas</h5>
            </div>
            <div class="col col-md-6 col-sm-12 text-center">
              <div class="avatar-md mx-auto mb-3">
                <div
                  class="avatar-title bg-light rounded-circle text-primary h1"
                >
                  <i class="bx bx-group"></i>
                </div>
              </div>
              <h5 class="text-primary">{{ wevent.totalPeserta }} Peserta</h5>
            </div>
          </div>
          <div class="row">
            <div class="col mt-2">
              <datatable
                :columns="wcolumns"
                :sortKey="wsortKey"
                :sortOrders="wsortOrders"
                @sort="wsortBy"
              >
                <tbody>
                  <tr v-if="wloadingTable">
                    <td colspan="16" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="wtable_data == ''">
                    <td class="text-center" colspan="16">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row_data, key_data) in wtable_data"
                    :key="key_data"
                  >
                    <template v-if="event.date == row_data.pbl_tgl_selesai">
                      <td
                        class="text-center"
                        style="background-color: #2980b9; color: #fff"
                      >
                        <div v-if="key_data + 1 == 10">
                          {{ currentTablePage }}0.
                        </div>
                        <div v-else>
                          {{
                            currentTablePage - 1 != 0
                              ? currentTablePage - 1
                              : ""
                          }}{{ key_data + 1 }}.
                        </div>
                      </td>
                      <td style="background-color: #2980b9; color: #fff">
                        {{ row_data.pbl_kode }}
                      </td>
                      <td
                        class="text-center"
                        style="background-color: #2980b9; color: #fff"
                      >
                        {{ row_data.pbl_tgl_mulai }}
                      </td>
                      <td
                        class="text-center"
                        style="background-color: #2980b9; color: #fff"
                      >
                        {{ row_data.pbl_tgl_selesai }}
                      </td>
                      <td
                        class="text-center"
                        style="background-color: #2980b9; color: #fff"
                      >
                        {{ row_data.pbl_lt_name }}
                      </td>
                      <td
                        class="text-center"
                        style="background-color: #2980b9; color: #fff"
                      >
                        {{ row_data.pbl_angkatan }}
                      </td>
                      <td style="background-color: #2980b9; color: #fff">
                        {{ row_data.pbl_judul }}
                      </td>
                      <td
                        class="text-center"
                        style="background-color: #2980b9; color: #fff"
                      >
                        {{ row_data.total_peserta }} Org
                      </td>
                    </template>
                    <template v-else>
                      <td class="text-center">
                        <div v-if="key_data + 1 == 10">
                          {{ currentTablePage }}0.
                        </div>
                        <div v-else>
                          {{
                            currentTablePage - 1 != 0
                              ? currentTablePage - 1
                              : ""
                          }}{{ key_data + 1 }}.
                        </div>
                      </td>
                      <td>{{ row_data.pbl_kode }}</td>
                      <td class="text-center">{{ row_data.pbl_tgl_mulai }}</td>
                      <td class="text-center">
                        {{ row_data.pbl_tgl_selesai }}
                      </td>
                      <td class="text-center">{{ row_data.pbl_lt_name }}</td>
                      <td class="text-center">{{ row_data.pbl_angkatan }}</td>
                      <td>{{ row_data.pbl_judul }}</td>
                      <td class="text-center">
                        {{ row_data.total_peserta }} Org
                      </td>
                    </template>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination
              :pagination="wpagination"
              @to-page="wtoPage"
            ></pagination>
          </div>
        </div>
      </div>
      <div class="text-end">
        <b-button variant="light" @click="closeModal">Tutup</b-button>
      </div>
    </b-modal>
  </Layout>
</template>
